import * as React from 'react';

import { Page, PageContent, PageHeader } from '../components/common';

class FourOhThreePage extends React.Component<{}, {}> {
	render() {
		return (
			<Page className="401 text-center" title="Unauthorized">
				<PageContent>
					<PageHeader isCentered={true}>
						<h1 className="display-1 text-secondary">403</h1>
						<h2 className="text-secondary mb-0">Unauthorized</h2>
					</PageHeader>
					<p className="mt-4">Sorry, you do not have access to the secret level.</p>
				</PageContent>
			</Page>
		);
	}
}

export default FourOhThreePage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/403Page.tsx